import Cookies from 'js-cookie';
import { HeroCarousel } from './sliders';
import GlobalMeasurements from './global-measurements';
import { BoneModal } from './BoneModal';
import { AddToCartEvent, SetEnquireButtonData, SingleProductEnquiryStart, ViewItemEvent } from './tracking';

const ProductPage = (() => {

	const pp = {
		initialised: false,
		hasAjax: false,
		variationsForm: undefined,
		variationsData: undefined,
		heroCarousel: undefined,
		fixedFooter: undefined,
		customiserSidebar: undefined,
		customiserSidebarModal: undefined,
		productType: undefined,

		productMeta: undefined,
		defaultPriceRange: undefined,
		priceDisplay: undefined,
		productVariationStock: undefined,
		addToCart: undefined,
		addToCartButton: undefined,

		defaultLeadTime: undefined,
		leadTimeDisplay: undefined,
	};

	pp.init = function() {
		// pp.hasAjax = !! window.wc_checkout_params;
		pp.setProductToCookie();
		pp.initHeroCarousel();
		pp.initCustomiserSidebar();
		pp.initFixedFooter();
		pp.initProductMeta();
		pp.initDefaultPriceRange();
		pp.initDefaultLeadTime();
		pp.initQuantityPicker();
		pp.initEnquiryButtons();
		// pp.setupChangeAttribute();

		if (pp.isVariableProduct()) {
			pp.setupVariations();
			pp.setHiddenVariationId();
			pp._onRequestCheckVariation();
		}
	}

	pp.isVariableProduct = function() {
		const variForm = document.querySelector('form.variations_form');
		return !!variForm;
	}

	pp.blockUI = function() {
		pp.productMeta.setAttribute('aria-disabled', 'true');
		pp.customiserSidebar.setAttribute('aria-disabled', 'true');
		if (pp.fixedFooter && pp.fixedFooter.elem) {
			pp.fixedFooter.elem.setAttribute('aria-disabled', true);
		}
	}

	pp.unblockUI = function() {
		pp.productMeta.setAttribute('aria-disabled', 'false');
		pp.customiserSidebar.setAttribute('aria-disabled', 'false');
		if (pp.fixedFooter  && pp.fixedFooter.elem) {
			pp.fixedFooter.elem.setAttribute('aria-disabled', false);
		}
	}


	pp.setupChangeAttribute = function() {
		const attrRadios = Array.from(document.querySelectorAll('.product-info__variation-radio'));

		if(!pp.productMeta)  {
			return;
		}

		const isVariable = pp.productMeta.getAttribute('data-variable-product');

		if (!attrRadios || isVariable !== 'true') {
			return;
		}

		attrRadios.forEach((radio) => {
			radio.addEventListener('change', pp._onRequestCheckVariation);
		})

		// Run the check initially to set the price
		pp._onRequestCheckVariation();
	}

	pp.updatePriceRange = function(priceHtml) {
		if(!pp.priceDisplay) {
			return;
		}

		if(priceHtml) {
			pp.priceDisplay.forEach(priceDisplay => {
				priceDisplay.innerHTML = `${priceHtml} <small>AUD</small>`;
			});
		} else if(pp.defaultPriceRange) {
			pp.priceDisplay.forEach(priceDisplay => {
				priceDisplay.innerHTML = pp.defaultPriceRange;
			});
		}
	}

	pp.updateLeadTime = function(leadTime) {
		if(!pp.leadTimeDisplay) {
			return;
		}

		if(leadTime) {
			pp.leadTimeDisplay.forEach(leadTimeDisplay => {
				leadTimeDisplay.innerHTML = leadTime;
			});
		} else if(pp.defaultLeadTime) {
			pp.leadTimeDisplay.forEach(leadTimeDisplay => {
				leadTimeDisplay.innerHTML = pp.defaultLeadTime;
			});
		}
	}

	pp.updateVariationStock = function(availabilityValue = null, stockValue = false) {

		if(pp.productVariationStock) {
			pp.productVariationStock = availabilityValue;
		}

		if( pp.addToCart ) {
			pp.addToCart.setAttribute(
				'data-show-stock', stockValue
			);
		}
	}

	pp.enableAddToCart = function() {
		if(!pp.addToCartButton) {
			return;
		}

		pp.addToCartButton.removeAttribute('disabled');
	}

	pp.disableAddToCart = function() {
		if(!pp.addToCartButton) {
			return;
		}

		pp.addToCartButton.setAttribute('disabled', '');
	}

	pp._onRequestCheckVariation = function(e) {
		if (!pp.variationsForm) {
			return;
		}

		const productIdInput = pp.variationsForm.querySelector('input[name="product_id"]');
		const productId = productIdInput && productIdInput.value;

		let data = {
			action: 'get_variation',
			product_id: productId || null,
		}

		const formAttributes = pp.variationsForm.querySelectorAll('[data-attribute_name]');
		if (formAttributes.length) {
			Array.from(formAttributes).forEach((attr) => {
				data[attr.name] = attr.value;
			});
		}

		if (productId) {
			pp.blockUI();

			$.ajax( {
				type:     'POST',
				url:      '/?wc-ajax=get_variation',
				dataType: 'html',
				data: data,
				success:  function( response ) {
					const data = JSON.parse(response);

					if(data) {
						const {
							price_html,
							availability_html,
							show_variation_stock,
							variation_lead_time,
							cart_action,
						} = data;

						const leadTimeValue = 'consultation' === cart_action
							? variation_lead_time
							: availability_html;

						// Run tracking
						ViewItemEvent(data);
						SetEnquireButtonData(data);

						// Update items
						pp.updatePriceRange(price_html);
						pp.updateLeadTime(leadTimeValue);
						pp.updateCartAction(cart_action);
						pp.enableAddToCart();
					} else {
						pp.updateCartAction('oos');
						pp.updatePriceRange();
						pp.updateLeadTime();
						pp.updateVariationStock();
						pp.disableAddToCart();
					}
				},
				complete: function() {
					pp.unblockUI();
				},
				error: function(response) {
					console.log({response})
					pp.unblockUI();
				},
			});
		}
	}

	pp.validatateChange

	pp.setUIForCurrentVariation = function(productId) {
		if (!pp.variationsData) {
			return;
		}

		const attributes = pp.getLiveAttributes();
		const currentVariation = pp.getCurrentVariation();

		let selectStates = [];
		attributes.forEach((attr, i) => {
			const testAttrs = attributes.slice(0, i);
			const matchingVariations = pp.variationsData.filter(v => pp.matchesAttributes(v, testAttrs));

			const selectableValues = matchingVariations.map(v => v.attributes[attr.slug]);
			const uniqueValues = new Set(selectableValues);

			selectStates.push({
				attribute: attr.slug,
				value: attr.value,
				variations: matchingVariations,
				canSelect: Array.from(uniqueValues),
			})
		});


		const hasValidVariation = !!currentVariation;

		selectStates.forEach(state => {
			const attrId = state.attribute.replace(/^attribute_/, '');
			const proxies = pp.getProxiesFor(attrId);

			proxies.forEach(proxy => {
				if (hasValidVariation) {
					if (state.canSelect.includes(proxy.value)) {
						proxy.removeAttribute('disabled');
					}
					else {
						proxy.setAttribute('disabled', 'true');
					}
				}
				else {
					proxy.removeAttribute('disabled');
				}
			})
		});
	}


	pp.matchesAttributes = function(variation, attrs) {
		let toBeMatched = attrs.length;
		attrs.forEach(attr => {
			if (variation.attributes[attr.slug] === attr.value) {
				toBeMatched--;
			}
		})

		return toBeMatched === 0;
	}

	pp.updateCartAction = function(action) {
		if (!action) {
			return;
		}

		const actionClass = `cart-action--${action}`;
		const oldActions = Array.from(document.body.classList).filter(c => c.startsWith('cart-action--'));
		if (oldActions.length) {
			oldActions.forEach(oldAction => {
				document.body.classList.remove(oldAction);
			})
		}

		document.body.classList.add(actionClass);

		const updateSidebarTriggers = false;
		if (updateSidebarTriggers) {
			const sidebarTriggers = Array.from(
				document.querySelectorAll('[data-open-trigger-for="customiser-sidebar"], .sidebar-close-header > h5')
			);

			if (sidebarTriggers.length) {
				sidebarTriggers.forEach(trigger => {
					let label = 'Enquire';
					if ('purchase' === action) {
						label = 'Purchase';
					}
					else if ('backorder' === action) {
						label = 'Backorder';
					}

					trigger.innerHTML = label;
				})
			}
		}
	}

	pp.setProductToCookie = function() {

		let gdRecentlyViewedCookie = Cookies.get('gd_recently_viewed');

		if (!gdRecentlyViewedCookie) {
			gdRecentlyViewedCookie = [];
		} else {
			gdRecentlyViewedCookie = JSON.parse(gdRecentlyViewedCookie);
		}

		const productFooterBtnLockup = document.querySelector('.product-body .product-footer__button-lockup');
		if (productFooterBtnLockup && !gdRecentlyViewedCookie.includes(parseInt(productFooterBtnLockup.dataset.productId))) {
			gdRecentlyViewedCookie.push(parseInt(productFooterBtnLockup.dataset.productId));
		}

		if (gdRecentlyViewedCookie.length > 9) {
			gdRecentlyViewedCookie.shift();
		}

		gdRecentlyViewedCookie = Array.from(new Set(gdRecentlyViewedCookie));

		Cookies.set('gd_recently_viewed', JSON.stringify(gdRecentlyViewedCookie));

	}

	pp.setupVariations = function() {
		const variForm = document.querySelector('form.variations_form');
		if (variForm) {
			pp.variationsForm = variForm;
		}

		const dataForm = document.querySelector('form[data-product_variations]'); // this may not be the same form as variForm
		if (dataForm) {
			try {
				const data = JSON.parse(dataForm.dataset.product_variations);
				pp.variationsData = data || false;
			}
			catch (err) {
				pp.variationsData = false;
			}
		}

		const proxies = Array.from(document.querySelectorAll('[data-proxy-for][value]'));
		if (proxies && proxies.length) {
			proxies.forEach(proxy => {
				proxy.addEventListener('change', pp._onProxyClick);
			})
		}
	}

	pp.getLiveAttributes = function () {
		if (!pp.variationsForm) {
			return;
		}

		const formData = new FormData(pp.variationsForm);
		const attributes = Array.from(formData).filter(([key, _]) => key.startsWith('attribute_'));

		return attributes.map(attr => {
			const [slug, value] = attr;

			return {
				slug,
				value,
			}
		})
	}

	/**
	 *
	 * @returns Object|false
	 */
	pp.getCurrentVariation = function() {
		const attributes = pp.getLiveAttributes();
		if (!attributes || !pp.variationsData) {
			return
		}

		const currentVariation = pp.variationsData.find(variation => {
			return pp.matchesAttributes(variation, attributes);
		});

		return currentVariation || false;
	}

	pp.setHiddenVariationId = function() {
		const inputs = Array.from(document.querySelectorAll('input[name="variation_id"]'));
		if (!inputs.length) {
			return;
		}

		const variation = pp.getCurrentVariation();
		// console.log('Current variation:', variation);
		const invalidId = 0;
		let id = invalidId;
		if (variation) {
			id = variation.variation_id;
		}

		inputs.forEach(input => {
			input.value = id;
		});
	}

	pp._onProxyClick = function(e) {
		const proxy = e.target;

		pp.propagateProxyChange(proxy);
		const currentVariation = pp.getCurrentVariation();

		if (!currentVariation) {
			pp.reconcileVariationAttributes(proxy);
		}

		pp.setUIForCurrentVariation();
		pp.setHiddenVariationId();
		pp._onRequestCheckVariation();
	}

	pp.propagateProxyChange = function(proxy) {
		const proxiedFieldId = proxy.dataset.proxyFor;
		const proxiedField = document.getElementById(proxiedFieldId);
		const newValue = proxy.value;

		if (proxiedField) {
			// TODO: check if proxied value is valid (e.g. is available in a select)
			proxiedField.value = newValue;
			$(proxiedField).trigger('change'); // needs to be jquery so woocomm detects it
		}


		// synchronise value with other proxies for the same field
		const sharedProxies = Array.from(pp.getProxiesFor(proxiedFieldId));
		sharedProxies
			.filter(p => p.value === newValue && p !== proxy)
			.forEach(p => {
				p.checked = true;
			})
	}

	/**
	 *
	 * @param {?string} selector
	 * @return {array}
	 */
	pp.getProxiesFor = function(id) {
		const proxies = Array.from(document.querySelectorAll(`[data-proxy-for="${id}"]`));
		return proxies;
	}

	pp.reconcileVariationAttributes = function(lastChanged) {
		if (pp.getCurrentVariation()) {
			// do nothing, variation already reconciled with current attributes
			return;
		}

		const attrs = pp.getLiveAttributes();
		let attrsToMatch = undefined;
		if (lastChanged && lastChanged.value && lastChanged.name) {
			// name needs to be of the form attribute_pa_<attrname>.
			// lastChanged.name may need to be converted from proxy_pa_attrname or pa_attrname
			const name = lastChanged.name.replace(/^(proxy_)?pa_/, 'attribute_pa_');

			const endIndex = attrs.findIndex(a => a.slug === name);
			if (endIndex >= 0) {
				attrsToMatch = attrs.slice(0, endIndex + 1); // +1 because slice end is non-inclusive
			}
		}
		else {
			attrsToMatch = attrs.slice(0, 1); // just use first attribute
		}

		if (!attrsToMatch) {
			// do nothing - only one attribute
			// Note: this shouldn't really happen, as if the product only has one attribute
			// there should always be a matching variation.
			return;
		}


		let quickestMatch = pp.variationsData.find(v => pp.matchesAttributes(v, attrsToMatch));

		const reconciledVariation = quickestMatch;

		if (reconciledVariation) {

			// update field values and their proxies
			Object.keys(reconciledVariation.attributes).forEach(key => {
				const value = reconciledVariation.attributes[key];
				const keyAsId = key.replace(/^attribute_/, '');

				const field = document.getElementById(keyAsId);
				field.value = value;

				const proxies = pp.getProxiesFor(keyAsId);
				proxies.forEach(proxy => {
					proxy.checked = proxy.value === value;
				})
			});

			pp.setHiddenVariationId();
			pp.setUIForCurrentVariation();
		}
	}

	pp.initProductMeta = function() {
		const productMeta = document.querySelector('.product-meta');

		if (!productMeta) {
			return;
		}

		pp.productMeta = productMeta;
	}

	pp.initVariationStock = function() {
		const productVariationStock = document.querySelector('.woocommerce-variation-availability');

		if (!productVariationStock) {
			return;
		}

		pp.productVariationStock = productVariationStock;
	}

	pp.initDefaultLeadTime = function() {
		const selectors = [
			'.product-fixed-footer-info__summary-leadtime', // mobile layout
			'.add-to-cart-meta__availability',
		];

		const leadTimeDisplay = document.querySelectorAll(selectors);
		if (!leadTimeDisplay.length) {
			return;
		}

		pp.leadTimeDisplay = leadTimeDisplay;
		pp.defaultLeadTime = leadTimeDisplay[0].innerHTML;
	}

	pp.initDefaultPriceRange = function() {
		const selectors = [
			// '.woocommerce-variation.single_variation', // customise sidebar
			'.product-fixed-footer-info__summary-price', // mobile layout
			'.add-to-cart-meta__price',
		];

		const priceDisplay = document.querySelectorAll(selectors.join(','));
		if (!priceDisplay.length) {
			return;
		}

		pp.priceDisplay = priceDisplay;
		pp.defaultPriceRange = priceDisplay[0].innerHTML;
	}

	pp.initQuantityPicker = function() {
		const pickers = Array.from(document.querySelectorAll('input[name="quantity_proxy"]'));
		if (!pickers.length) return;

		pickers.forEach(picker => {
			const parentForm = picker.closest('form');
			if (!parentForm) return;

			const canonicalInput = parentForm.querySelector('input[name="quantity"]');
			if (!canonicalInput) return;

			picker.addEventListener('change', (e) => {
				canonicalInput.value = picker.value;
			});
		})
	}

	pp.initHeroCarousel = function() {
		const rootElem = document.querySelector('.product-hero__carousel.f-carousel');
		if (!rootElem) {
			return;
		}

		pp.heroCarousel = new HeroCarousel(rootElem);

		// resize again to combat sizing issues
		window.addEventListener('load', () => {
			if (pp.heroCarousel) {
				pp.heroCarousel.carousel.resize();
			}
		}, {once: true})

		setTimeout(() => {
			if (pp.heroCarousel) {
				pp.heroCarousel.carousel.resize();
			}
		}, 100);

		setTimeout(() => {
			if (pp.heroCarousel) {
				pp.heroCarousel.carousel.resize();
			}
		}, 200);

		setTimeout(() => {
			if (pp.heroCarousel) {
				pp.heroCarousel.carousel.resize();
			}
		}, 500);
	}

	pp.unloadHeroCarousel = function() {
		if (pp.heroCarousel) {
			// console.log(pp.heroCarousel)
			// pp.heroCarousel.destroy();
		}
	}

	pp.initCustomiserSidebar = function() {
		const elem = document.getElementById('customiser-sidebar');
		const addToCart = document.querySelector('.add-to-cart');
		const addToCartButton = document.querySelector('.single_add_to_cart_button');

		if (!elem) {
			return;
		}

		if(addToCartButton) {
			pp.addToCartButton = addToCartButton;
			addToCartButton.addEventListener('click', function() {
//				AddToCartEvent();
			});
		}

		if(addToCart) {
			pp.addToCart = addToCart;
		}

		pp.customiserSidebar = elem;

		const modal = new BoneModal(elem);
		if (modal.instantiated) {
			pp.customiserSidebarModal = modal;
		}
	}


	pp.openCustomiserSidebar = function() {
		if (pp.customiserSidebarModal) {
			pp.customiserSidebarModal.open();
		}
	}

	pp.closeCustomiserSidebar = function() {
		if (pp.customiserSidebarModal) {
			pp.customiserSidebarModal.close();
		}
	}

	pp.initEnquiryButtons = function() {
		const enquireForms = Array.from(document.querySelectorAll('.single-product-enquire-form'));
		if (!enquireForms.length) {
			return;
		}

		/**
		 * GForms replaces human-readable input names with input_1 etc., so we search
		 * for the variant_info field using its placeholder value, and tag it with
		 * a data-name attribute instead so it can be easily found.
		 */
		enquireForms.forEach((form) => {
			const hiddenInputs = Array.from(form.querySelectorAll('input[type="hidden"]'));
			hiddenInputs.forEach((input) => {
				if (input.value === '#VARIATION_PLACEHOLDER#') {
					input.setAttribute('data-name', 'variant_info');
					if (!pp.isVariableProduct()) {
						input.value('Not a variable product');
						input.dispatchEvent(new Event('change')); // in case GF needs to know of the change
					}
				}
			})
		})

		const triggers = document.querySelectorAll('.enquire-button');
		const mobileTrigger = document.querySelector('.button.enquire-button-mobile');
		let allTriggers = [];
		if( triggers.length ) {
			Array.from(triggers).forEach((trigger) => {
				allTriggers.push(trigger);
			})
		}

		if( mobileTrigger ) {
			allTriggers.push(mobileTrigger);
		}

		if (!allTriggers.length) {
			return;
		}

		if (!pp.isVariableProduct()) {
			return;
		}

		// variable-product specific stuff
		allTriggers.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				const variation = pp.getCurrentVariation();

				if (!variation) {
					return;
				}

				SingleProductEnquiryStart(variation);

				const lines = [];

				Object.keys(variation.attributes).forEach((key) => {
					lines.push(variation.attributes[key]);
				})

				lines.push(`ID: ${variation.variation_id}`);

				const variationInfo = lines.join(' / ');

				enquireForms.forEach((form) => {
					const variantField = form.querySelector('input[data-name="variant_info"]');
					if (!variantField) {
						return;
					}

					variantField.value = variationInfo;
					variantField.dispatchEvent(new Event('change')); // in case GF needs to know of the change
				});
			})
		})
	}

	pp.initFixedFooter = function() {
		const baseClass = 'product-fixed-footer';
		const footer = document.querySelector(`.${baseClass}`);
		if (!footer) {
			return;
		}

		const fixedFooterInstance = {
			elem: footer,
			unload: () => {},
		}

		const expandableArea = document.querySelector(`.${baseClass}__expandable-area`);
		if (expandableArea) {

			// this will provide the collapsed height
			const fixedArea = document.querySelector(`.${baseClass}__fixed-area`);

			const openTriggers = Array.from(document.querySelectorAll(`.${baseClass}__btn--open`));
			const closeTriggers = Array.from(document.querySelectorAll(`.${baseClass}__btn--close`));

			const openFooter = () => {

				if (fixedArea) {
					// set initial height for animation
					footer.style.height = fixedArea.clientHeight + 'px';
				}

				footer.classList.add(`${baseClass}--expanded`);
				expandableArea.setAttribute('aria-hidden', 'false');
				openTriggers.forEach(trigger => {
					trigger.setAttribute('aria-expanded', 'true');
					trigger.setAttribute('disabled', 'true')
				})

				closeTriggers.forEach(trigger => {
					trigger.removeAttribute('disabled');
				})
				document.body.classList.add('product-bar-active');

				requestAnimationFrame(() => {
					footer.style.height = '100dvh';
				});
			}

			const closeFooter = () => {
				footer.classList.remove(`${baseClass}--expanded`);
				expandableArea.setAttribute('aria-hidden', 'true');

				if( closeTriggers ) {
					closeTriggers.forEach(trigger => {
						trigger.setAttribute('disabled', 'true')
					})
				}

				if( openTriggers ) {
					openTriggers.forEach(trigger => {
						trigger.setAttribute('aria-expanded', 'false');
						trigger.removeAttribute('disabled');
					})
				}
				document.body.classList.remove('product-bar-active');

				if (fixedArea) {
					footer.style.height = fixedArea.clientHeight + 'px';
				}
				else {
					footer.style.height = 'auto';
				}
			}

			openTriggers.forEach((trigger) => {
				trigger.addEventListener('click', openFooter);
			})

			closeTriggers.forEach((trigger) => {
				trigger.addEventListener('click', closeFooter);
			})

			const measureFooter = () => {
				const productFooter = document.querySelector(`.${baseClass}__fixed-area`);

				return {
					prop: 'product-footer',
					value: productFooter ? `${productFooter.scrollHeight}px` : false,
				}
			}

			GlobalMeasurements.add(measureFooter);

			// set up unload function while have access to everything
			fixedFooterInstance.unload = () => {
				openTriggers.forEach((trigger) => {
					trigger.removeEventListener('click', openFooter);
				})

				closeTriggers.forEach((trigger) => {
					trigger.removeEventListener('click', closeFooter);
				})

				GlobalMeasurements.remove(measureFooter);

				pp.fixedFooter = undefined;
			}
		}

		pp.fixedFooter = fixedFooterInstance;
	}

	pp.unloadFixedFooter = function() {
		if (pp.fixedFooter && pp.fixedFooter.unload) {
			pp.fixedFooter.unload();
		}
	}

	pp.unload = function() {
		const proxies = Array.from(document.querySelectorAll('[data-proxy-for]'));
		if (proxies && proxies.length) {
			proxies.forEach(proxy => {
				proxy.removeEventListener('change', pp._onProxyClick);
			})
		}

		pp.unloadHeroCarousel();

		pp.unloadFixedFooter();
	}

	return pp;

})();

export default ProductPage;



// WEBPACK FOOTER //
// ./scripts/modules/product-page.js